var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C8.14466 2 8.2834 2.05747 8.38569 2.15976C8.48799 2.26205 8.54545 2.40079 8.54545 2.54545V7.45455H13.4545C13.5992 7.45455 13.7379 7.51201 13.8402 7.61431C13.9425 7.7166 14 7.85534 14 8C14 8.14466 13.9425 8.2834 13.8402 8.38569C13.7379 8.48799 13.5992 8.54545 13.4545 8.54545H8.54545V13.4545C8.54545 13.5992 8.48799 13.7379 8.38569 13.8402C8.2834 13.9425 8.14466 14 8 14C7.85534 14 7.7166 13.9425 7.61431 13.8402C7.51201 13.7379 7.45455 13.5992 7.45455 13.4545V8.54545H2.54545C2.40079 8.54545 2.26205 8.48799 2.15976 8.38569C2.05747 8.2834 2 8.14466 2 8C2 7.85534 2.05747 7.7166 2.15976 7.61431C2.26205 7.51201 2.40079 7.45455 2.54545 7.45455H7.45455V2.54545C7.45455 2.40079 7.51201 2.26205 7.61431 2.15976C7.7166 2.05747 7.85534 2 8 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5f27c55a9c89259f387f964ae0daf856.svg";
export { ForwardRef as ReactComponent };